'use client';

import { useParams, useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { getOrganisations } from '@/lib/api/organisations';

export default function Home() {
  const router = useRouter();
  const { lng } = useParams();

  useEffect(() => {
    getOrganisations().then((data) => {
      if ('error' in data) {
        return router.push(`/${lng}/auth`);
      }

      router.push(`/${lng}/dash/${data[0].orgId}`);
    });
  });

  return <div className="bg-bg-light-primary dark:bg-bg-dark-primary" />;
}
